

window.clog = console.log.bind(document);
window.clr  = {}